import first from 'lodash/first';
import get from 'lodash/get';

export const useTarget = () => {
  const isSafari = get(window, 'navigator.vendor', '').startsWith('Apple');
  const behavior = isSafari ? 'auto' : 'smooth';
  const getTarget = (target: string) => document.querySelector(`[data-target='${target}']`) as HTMLElement;

  const scrollTo = (target: string, block: ScrollLogicalPosition = 'start') => {
    let el;

    if (target) {
      el = getTarget(target);
    } else {
      const targets = document.querySelectorAll('[data-target][data-target-scroll]');

      el = first(targets);
    }

    if (el) {
      el.scrollIntoView({ block, behavior });
    }
  };

  const isVisible = (target: string) => !!getTarget(target);
  const focusTarget = (target: string) => getTarget(target)?.focus();

  return { focusTarget, getTarget, isVisible, scrollTo };
};
